module.exports = "\n<div class='flexbox-button-vma hNine' openAccountManagement data-slnm-ihg='viewMyAccountButtonSID' [innerText]=\"messages['links.viewaccount.label']\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/view-my-account/view-my-account.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/view-my-account/view-my-account.component.html
// module chunks = 0